import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const questionsList = createSlice({
  name: 'questionsList',
  initialState,
  reducers: {
    getQuestionsListRequest: handlers.getQuestionsListRequest,
    getQuestionsListSuccess: handlers.getQuestionsListSuccess,
    getQuestionsListFailure: handlers.getQuestionsListFailure,
  },
});

const { actions, reducer } = questionsList;

export const { getQuestionsListRequest, getQuestionsListSuccess, getQuestionsListFailure } = actions;

export default reducer;
